export type PaletteOption = {
  id: string;
  hex: string;
  label: string;
};

export const PALETTE_OPTIONS: PaletteOption[] = [
  { id: 'forest', hex: '#1E3A2A', label: 'Forest' },
  { id: 'brick', hex: '#A0392C', label: 'Brick' },
  { id: 'gold', hex: '#D4A846', label: 'Gold' },
  { id: 'navy', hex: '#2C4A6B', label: 'Navy' },
  { id: 'plum', hex: '#6B3A5C', label: 'Plum' },
  { id: 'ochre', hex: '#8B5A2B', label: 'Ochre' },
];

export function paletteById(id: string | null | undefined): PaletteOption {
  return PALETTE_OPTIONS.find((p) => p.id === id) ?? PALETTE_OPTIONS[0];
}
